import React from "react";
import {observer} from "mobx-react";
import {StationDropDownComponent} from "./station-drop-down.component";
import {useServices} from "../../../../hooks/use-services.hook";
import {FieldEditorCommonProps} from "../../../forms/inputs-common.props";
import {FlightSearchDropDownIconComponent} from "../../common/flight-search-drop-down-icon.component";
import {useContainerMediaQueriesChecks} from "../../../../hooks/use-container-media-queries-checks.hook";
import {PlaneDepartingLineNotFilledIcon} from "../../../../assets/svg/plane-departing-line-not-filled.icon";

export const DestinationStationDropDownComponent: React.FC<FieldEditorCommonProps> = observer((props) => {

    const services = useServices();
    const mediaQuery = useContainerMediaQueriesChecks();

    const searchController = services.flightSearch.searchController;
    const getDestinationStations = () => {
        return searchController.availableDestinationStations;
    }


    const renderDestinationNoStationMessage = () => {
        if(!searchController.origin) {
            return services.language.translate('Select departure first');
        }

        return services.language.translate('No destination available');
    }

    const renderIcon = () => {

        if(mediaQuery.mAndBelow) {
            return (<FlightSearchDropDownIconComponent isHidden={true} icon={<PlaneDepartingLineNotFilledIcon size={1}/>}/>);
        }

        return null;
    }

    return (
        <StationDropDownComponent  {...props}
                                   field={searchController.fields.destination}
                                   renderLabel={() => services.language.translate('Destination')}
                                   renderIcon={renderIcon}
                                   getStations={getDestinationStations}
                                   placeholder={services.language.translate('Select destination')}
                                   noStationsMessage={renderDestinationNoStationMessage}/>
    )
})